import { Link } from 'react-router-dom';
import { Home, Sparkles, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#0A0A0F] text-white relative overflow-hidden flex items-center justify-center" data-testid="not-found">
      {/* Aurora */}
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[800px] h-[600px] rounded-full bg-[#FF6B4A]/15 blur-[120px] pointer-events-none" />
      <div className="absolute top-0 right-0 w-[400px] h-[400px] rounded-full bg-[#E040A0]/15 blur-[120px] pointer-events-none" />

      <div className="relative text-center px-6 max-w-xl">
        <div className="font-display text-[180px] sm:text-[240px] font-black leading-none tracking-[-0.05em] bg-gradient-to-br from-[#FF6B4A] via-[#E040A0] to-[#FFD93D] bg-clip-text text-transparent" data-testid="not-found-code">
          404
        </div>
        <p className="text-[10px] font-bold tracking-[0.3em] uppercase text-[#FFD93D] mt-2 mb-4">Lost in latent space</p>
        <h1 className="font-display text-3xl sm:text-5xl font-black tracking-tight uppercase mb-4">This pixel doesn&apos;t exist.</h1>
        <p className="text-sm text-white/55 mb-8 leading-relaxed">
          The page you tried to render isn&apos;t in our manifold yet. Hit the studio and create one — or head back home.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/">
            <Button className="bg-gradient-to-r from-[#FF6B4A] to-[#E040A0] text-white font-bold uppercase tracking-[0.15em] px-7 py-5 text-xs rounded-full hover:from-[#FF8E72] hover:to-[#FF6B9D] shadow-[0_8px_24px_rgba(255,107,74,0.3)] transition-shadow" data-testid="404-home">
              <Home className="w-3.5 h-3.5 mr-2" /> Home
            </Button>
          </Link>
          <Link to="/models">
            <Button variant="outline" className="border-white/[0.15] text-white bg-white/[0.04] px-7 py-5 text-xs font-bold uppercase tracking-[0.15em] rounded-full hover:bg-white/[0.08] transition-colors" data-testid="404-models">
              <Sparkles className="w-3.5 h-3.5 mr-2" /> Browse 150 models <ArrowRight className="w-3 h-3 ml-2" />
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
